<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright3"><a id="page_iv"></a><a id="copy">    © 2013 By Stephen M. Hood</a></p><a id="copy">
<p class="copyright3">    All rights reserved. No part of this publication may be reproduced, stored in a<br/>
retrieval system, or transmitted, in any form or by any means, electronic, mechanical,<br/>
photocopying, recording, or otherwise, without the prior written permission of the<br/>
publisher.</p>
<p class="copyright3">    Hood, Stephen M.<br/>
    John Bell Hood: the Rise, Fall, and Resurrection of a Confederate General /<br/>
Stephen M. Hood. — First edition.<br/>
    pages cm<br/>
    Includes bibliographical references and index.<br/>
    EPUB ISBN 978-1-61121-140-5<br/>
    PRINT ISBN 978-1-61121-141-2<br/>

    1. Hood, John Bell, 1831-1879. 2. Generals—Confederate States of America—<br/>
Biography. 3. United States—History—Civil War, 1861-1865—Biography. 4. United<br/>
States—History—Civil War, 1861-1865—Campaigns. I. Title.<br/>
    E467.1.H58H66 2013<br/>
    355.0092—dc23<br/>
    [B]<br/>
    2013010919</p>
<p class="copyright3">First edition, first printing</p>
<p class="copyright3">    <img alt="" src="images/sb.jpg"/><br/>
    Published by<br/>
    Savas Beatie LLC<br/>
    989 Governor Drive, Suite 102<br/>
    El Dorado Hills, California 95762</p>
</a><p class="copyright3"><a id="copy">    Phone: 916-941-6896<br/>
    (E-mail) </a><a href="mailto:sales@savasbeatie.com">sales@savasbeatie.com</a><br/>
    (Website) <a href="http://www.savasbeatie.com" target="_blank">www.savasbeatie.com</a></p>
<p class="copyright3">    Savas Beatie titles are available at special discounts for bulk purchases in the<br/>
United States by corporations, institutions, and other organizations. For more details,<br/>
please contact Special Sales, P.O. Box 4527, El Dorado Hills, CA 95762, or you may<br/>
e-mail us at sales@savasbeatie.com, or visit our website at <a href="http://www.savasbeatie.com" target="_blank">www.savasbeatie.com</a> for<br/>
additional information.</p>
<p class="copyright3">    Printed in the United States of America.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?53ab9e6a